<template>
  <section id="page-privacy-policies">
    <div class="container">
      <div class="row">
        <clearfix :biggest="true"></clearfix>
      </div>

      <div class="row">
        <div class="col-sm-12 content fb-bg-light">
          <h4>Privacy</h4>
          <p>
            We don't store or use or care about using any personal data or personal information about you or any
            other visitors ... The only analytics tool used on these pages is <a href="https://usage.foobar.beer">webalizer + access log</a>.
          </p>
        </div>
      </div>

      <div class="row">
        <clearfix :biggest="true"></clearfix>
      </div>

      <div class="row">
        <div class="col-sm-12 content fb-bg-light">
          <h4>License</h4>
          <p>
            All the content on this site is available under <a href="http://wtfpl.net">WTFPL</a>.
          </p>

          <pre>
            DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
            Version 2, December 2004

            Copyright (C) 2004 Sam Hocevar &lt;sam@hocevar.net&gt;

            Everyone is permitted to copy and distribute verbatim or modified
            copies of this license document, and changing it is allowed as long
            as the name is changed.

                  DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
            TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION

            0. You just DO WHAT THE FUCK YOU WANT TO.
          </pre>
        </div>
      </div>

      <div class="row">
        <clearfix :biggest="true"></clearfix>
      </div>
    </div>
  </section>
</template>

<script>
  import Clearfix from '@/components/utils/Clearfix'

  export default {
    components: { Clearfix }
  }
</script>

<style>
#page-privacy-policies {
background: url('../../assets/img/bg/coding.jpg') center fixed no-repeat;
background-size: cover;
height: auto;
margin: 0 auto;
width: 100%;
position: relative;
padding: 30px 0;
}
</style>



// WEBPACK FOOTER //
// PrivacyPolicies.vue?6c4625ce